export type Notification = {
  notificationID: number;
  type: string;
  userID: string;
  createdAt: string;
  openedAt?: string | null;
  notificationData: Purchase | Announcement | ReleaseReminder;
};

export type Purchase = {
  purchaseID: number;
  sellerID: string;
  buyerID: string;
  creationID: number;
  creationName: string;
  creationNameJA: string | null;
  creationImageURL: string;
  price: string;
  availableTokenAmount: number;
  createdAt: string; // ISO 8601
};

export type Announcement = {
  announcementID: number;
  title: string;
  titleJA: string;
  content: string;
  contentJA: string;
  createdAt: string; // ISO 8601
  updatedAt: string; // ISO 8601
};

export type ReleaseReminder = {
  releaseReminderID: number;
  creationID: number;
  creationName: string;
  creationNameJA: string | null;
  creationImageURL: string;
  userID: string;
  userName: string;
  price: string;
  createdAt: string; // ISO 8601
};

export type ReadNotificationByNotificationIDsRequest = {
  notificationIDs: number[];
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isAnnouncement = (arg: any): arg is Announcement => {
  return !!arg?.announcementID;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isPurchase = (arg: any): arg is Purchase => {
  return !!arg?.purchaseID;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isReleaseReminder = (arg: any): arg is ReleaseReminder => {
  return !!arg?.releaseReminderID;
};
